// extracted by mini-css-extract-plugin
export default {"card":"Card_card__lCa4W","title":"Card_title__khi7m","number":"Card_number__OTSnx"};